import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold white-space-nowrap" }, "Kiểm tra lỗi dữ liệu thủ thuật theo quyết định 130 ")
], -1)
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Nhập mã bệnh án", -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_12 = {
  class: "p-input-icon-left",
  style: {"width":"22em"}
}
const _hoisted_13 = {
  class: "vertical-align-middle ml-2 font-bold line-height-3",
  style: {"font-weight":"bold"}
}
const _hoisted_14 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_15 = { id: "loading" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Đang xử lý xuất biên bản...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TabView, null, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_InputText, {
                    id: "name",
                    type: "text",
                    modelValue: $setup.maBenhAn,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.maBenhAn) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  ($setup.maBenhAn)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_9, "Kiểm tra dữ liệu"))
                    : _createCommentVNode("", true),
                  ($setup.maBenhAn)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        label: "Kiểm tra",
                        icon: "pi pi-plus-circle",
                        iconPos: "left",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.loadLoiDuLieu130()))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_DataTable, {
                    loading: _ctx.isLoading,
                    value: $setup.listLoi130,
                    paginator: true,
                    stripedRows: "",
                    rows: 50,
                    rowsPerPageOptions: [50,100,200],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['teN_DICH_VU'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} lỗi",
                    columnResizeMode: "fit | expand",
                    expandedRowGroups: $setup.expandedRowGroups,
                    "onUpdate:expandedRowGroups": _cache[5] || (_cache[5] = ($event: any) => (($setup.expandedRowGroups) = $event)),
                    expandableRowGroups: "",
                    rowGroupMode: "subheader",
                    groupRowsBy: "teN_DICH_VU",
                    sortMode: "single",
                    sortField: "teN_DICH_VU",
                    sortOrder: 1
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"6em"}
                        }),
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo loại thủ thuật"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    groupheader: _withCtx((slotProps) => [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(slotProps.data.teN_DICH_VU), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        header: "STT",
                        headerStyle: "width:3rem"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tenbenhnhan",
                        header: "Tên bệnh nhân",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "sophieu",
                        header: "Số phiếu",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "teN_DICH_VU",
                        header: "Tên dịch vụ",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "doN_VI_TINH",
                        header: "Đơn vị tính",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "sO_LUONG",
                        header: "Số lượng",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "mA_KHOA",
                        header: "Mã khoa",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "mA_GIUONG",
                        header: "Mã giường",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "mA_BAC_SI",
                        header: "Mã bác sĩ",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "nguoI_THUC_HIEN",
                        header: "Mã người thực hiện",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "ngaY_YL",
                        header: "Thời gian ra y lệnh",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngaY_YL)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "ngaY_TH_YL",
                        header: "Thời gian thực hiện y lệnh",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngaY_TH_YL)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "ngaY_KQ",
                        header: "Thời gian kết thúc y lệnh",
                        sortable: ""
                      }, {
                        body: _withCtx(({data}) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngaY_KQ)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "mA_MAY",
                        header: "Mã máy thực hiện",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "loi",
                        header: "Lỗi",
                        sortable: ""
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "value", "filters", "expandedRowGroups"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Dialog, {
        header: "Đang xử lý",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ]))
}